import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface ErrorState {
  status?: number | null
}

const initialState: ErrorState = {
  status: null,
}

export const errorSlice = createSlice({
  name: 'Error',
  initialState,
  reducers: {
    setError: (state: ErrorState, action: PayloadAction<number>) => {
      state.status = action.payload
    },
    clearError: (state: ErrorState) => {
      state.status = null
    },
  },
})

export const { setError, clearError } = errorSlice.actions

export default errorSlice.reducer